import React from 'react';

const ScoreGaugeWidget = ({ config = {} }) => {
  const title = config.title || 'Score';
  const value = config.value || 87;
  const maxValue = config.maxValue || 100;
  const color = config.color || '#3B82F6';
  const subtitle = config.subtitle || 'out of ' + maxValue;
  const size = config.size || 120;

  const percentage = Math.min((value / maxValue) * 100, 100);
  const radius = 45;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  const getColor = () => {
    if (config.autoColor) {
      if (percentage >= 80) return '#10B981';
      if (percentage >= 60) return '#F59E0B';
      return '#EF4444';
    }
    return color;
  };

  return (
    <div className="h-full flex flex-col items-center justify-center bg-white p-3">
      <h3 className="text-sm font-semibold text-gray-700 mb-2" style={{ color: config.titleColor || '#374151' }}>
        {title}
      </h3>
      <div className="relative" style={{ width: size, height: size }}>
        <svg viewBox="0 0 100 100" className="transform -rotate-90">
          <circle cx="50" cy="50" r={radius} fill="none" stroke="#E5E7EB" strokeWidth="8" />
          <circle
            cx="50" cy="50" r={radius} fill="none"
            stroke={getColor()}
            strokeWidth="8"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            style={{ transition: 'stroke-dashoffset 0.5s ease' }}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className="text-2xl font-bold" style={{ color: getColor() }}>{value}</span>
          <span className="text-xs text-gray-400">{subtitle}</span>
        </div>
      </div>
    </div>
  );
};

export default ScoreGaugeWidget;
